import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import { ReviseProjectProposalViewList } from 'features/ReviseProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ReviseProjectProposalViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="project_proposal">
            <ReviseProjectProposalViewList />
          </Can>
          <Can not do="read" on="project_proposal">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ReviseProjectProposalViewListPage;
